import { ResourcefulReducer } from '../../util';
import ACTIONS from '../actions';

const ResumeReducer = new ResourcefulReducer('resumes', undefined, {
  actionTypes: [ACTIONS.LIST_RESUMES.success, ACTIONS.FETCH_RESUME.success, ACTIONS.CREATE_RESUME.success, ACTIONS.UPLOAD_RESUME.success],
});

export default ResumeReducer;
